// removed by extract-text-webpack-plugin
module.exports = {"infoButton":"InfoButton__infoButton___xKLSk","image":"InfoButton__image___3Z-XV","info":"InfoButton__info___3auFx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoButton/InfoButton.css
// module id = 703
// module chunks = 0